export default "/images/de99ce377879d0ac4821c56e6acab906.avif";